export type CsvCell = string | number

/**
 * Serialize a header row and data rows into an RFC-4180-ish CSV string: every
 * cell quoted, embedded `"` doubled, rows joined with `\n`. Shared by every
 * client-side CSV export so the quoting/escaping rules live in one place.
 */
export const toCsvString = (headers: string[], rows: CsvCell[][]): string => {
  const quote = (cell: CsvCell): string =>
    `"${String(cell).replace(/"/g, '""')}"`
  const headerLine = headers.map(quote).join(',')
  const bodyLines = rows.map((row) => row.map(quote).join(',')).join('\n')
  return `${headerLine}\n${bodyLines}`
}
